import React from "react";
import SEO from "../components/shared/SEO";
import DashboardNavbar from "../components/shared/DashboardNavbar";
import SoloConnectFooter from "../components/shared/SoloConnectFooter";
import SoloConnectMobileFooter from "../components/shared/SoloConnectMobileFooter";
import WriterGuidelinesHero from "../components/dashboard/WriterGuidelinesHero";
import GuidelinesGrid from "../components/dashboard/GuidelinesGrid";
import PublishingRules from "../components/dashboard/PublishingRules";
import GuidelinesCTA from "../components/dashboard/GuidelinesCTA";

export default function WriterGuidelines() {
  return (
    <div className="flex flex-col min-h-screen bg-white">
      <SEO
        title="Blog Writer Guidelines | SoloConnect"
        description="Guidelines for writing and publishing travel blogs on SoloConnect."
        keywords="writer guidelines, blog rules, content policy, SoloConnect"
      />
      <DashboardNavbar />

      <main className="flex-grow">
        <WriterGuidelinesHero />
        <GuidelinesGrid />
        <PublishingRules />
        <GuidelinesCTA />
      </main>

      <div className="hidden md:block">
        <SoloConnectFooter />
      </div>
      <div className="block md:hidden">
        <SoloConnectMobileFooter />
      </div>
    </div>
  );
}
